import { AssignInvoiceCriteriaEntity, EMPTY_ASSIGN_INVOIC_CRITERIA_ENTITY } from "domain/entity/AssignInvoiceCriteria/AssignInvoiceCriteriaEntity";
import { AssignInvoiceCriteriaRepository } from "domain/repository/AssignInvoiceCriteria/AssignInvoiceCriteriaRepo";
import { ChargeTypeRepository } from "domain/repository/ChargeType/ChargeTypeRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { CustomerRepository } from "domain/repository/Company/CustomerRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import { TariffTypeRepository } from "domain/repository/TariffCode/TariffTypeRepo";
import _ from "lodash";
import { CntrStatusDroOpts } from "presentation/constant/DropDownOptions/Company/CntrStatusDroOpts";
import { AssignInvoiceCriteriaModel } from "presentation/model/AssignInvoiceCriteria/AssignInvoiceCriteriaModel";
import { DropdownProps } from "presentation/model/DropdownProps";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface dhocHoldOfCntrVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<AssignInvoiceCriteriaModel>> | ((value: SetStateAction<AssignInvoiceCriteriaModel>) => void),
    ],
    repo: AssignInvoiceCriteriaRepository,
    companyRepo: CompanyRepository,
    tariffTypeRepo: TariffTypeRepository,
    customerRepo: CustomerRepository,
    chargeTypeRepo: ChargeTypeRepository,
    parameterDetailRepo: ParameterDetailRepository,
}

export const AssignInvoiceCriteriaVM = ({ dispatch, repo, companyRepo, tariffTypeRepo, customerRepo, chargeTypeRepo, parameterDetailRepo }: dhocHoldOfCntrVMProps) => {
    const [assignInvoiceCriteriaDispatch] = dispatch;

    const loadDropdownOption = async () => {
        assignInvoiceCriteriaDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                containerStatusDropdownOptions: CntrStatusDroOpts().getDroOptsModel()
            }
        }))
        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let newCompanies = companies?.filter(company => company.companyType !== 'MASTER' && company.companyType !== 'ALLIANCE');

                let companyDropdownOptions = newCompanies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.id.toString(),
                    value: company.companyCode,
                })) ?? []
                companyDropdownOptions = _.orderBy(companyDropdownOptions, "dropdownLabel");

                assignInvoiceCriteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        billToCompanyDropdownOptions: companyDropdownOptions
                    }
                }))
            }
        );

        await tariffTypeRepo.getAllActiveTariffTypes().then(
            tariffs => {
                let newTariffs = _.orderBy(tariffs, ["tariffType"]);
                let tariffTypeDropdownOption = newTariffs?.map((tariff) => ({
                    dropdownLabel: tariff.tariffType,
                    tagLabel: tariff.tariffType,
                    value: tariff.tariffType,
                })) ?? []
                assignInvoiceCriteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        tariffTypeDropdownOptions: tariffTypeDropdownOption,
                    }
                }))
            }
        );

        await customerRepo.getCustomerActive().then(
            customers => {
                const sortCustomers = _.orderBy(customers, ["customerCode"]);
                let customerCodeDropdownOptions: DropdownProps[] = [];
                for (let i = 0; i < sortCustomers.length; i++) {
                    if (sortCustomers[i].id) {
                        customerCodeDropdownOptions.push({
                            dropdownLabel: sortCustomers[i].customerCode,
                            tagLabel: sortCustomers[i].id.toString(),
                            value: sortCustomers[i].customerCode
                        });
                    }
                }

                assignInvoiceCriteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        customerCodeDropdownOptions: customerCodeDropdownOptions,
                    }
                }))
            }
        );

        await chargeTypeRepo.getAllChargeTypesForCombobox().then(
            chargeTypes => {
                let newChargeTypeList = _.orderBy(chargeTypes, ["chargeType", "subChargeType"]);
                //let newChargeTypes = newChargeTypeList.filter(entity => entity.countFspInd === 'Y');
                let chargeTypeDropdownOption: DropdownProps[] = [];
                let subChargeTypeDropdownOption: { [key: string]: DropdownProps[] } = {};
                newChargeTypeList?.forEach(chgTypeEty => {
                    const chgTypeExisted = chargeTypeDropdownOption?.find(chgType =>
                        chgType.value === chgTypeEty.chargeType);
                    if (!chgTypeExisted && chgTypeEty.chargeType !== 'NO') {
                        chargeTypeDropdownOption.push({
                            dropdownLabel: chgTypeEty.chargeType,
                            tagLabel: chgTypeEty.chargeType,
                            value: chgTypeEty.chargeType
                        })
                    }
                    if (chgTypeEty.subChargeType) {
                        if (!subChargeTypeDropdownOption[chgTypeEty.chargeType]) {
                            subChargeTypeDropdownOption[chgTypeEty.chargeType] = [];
                        }
                        subChargeTypeDropdownOption[chgTypeEty.chargeType].push({
                            dropdownLabel: chgTypeEty.subChargeType,
                            tagLabel: chgTypeEty.subChargeType,
                            value: chgTypeEty.subChargeType
                        });
                    }
                });

                assignInvoiceCriteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        chargeTypeDropdownOptions: chargeTypeDropdownOption,
                        subChargeTypeDropdownOptions: subChargeTypeDropdownOption
                    }
                }))
            }
        );

        await parameterDetailRepo.getAllParameterDtlsByParameterCode("CNTR_SIZE").then(
            cntrSizeList => {
                const sizeDropdownOption = cntrSizeList?.map((cntrSize) => ({
                    dropdownLabel: cntrSize.parameterDtlCode,
                    tagLabel: cntrSize.parameterDtlCode,
                    value: cntrSize.parameterDtlCode,
                })) ?? []

                assignInvoiceCriteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        containerSizeDropdownOptions: sizeDropdownOption
                    }
                }))
            }
        );

        await parameterDetailRepo.getAllParameterDtlsByParameterCode("SHIPMENT_TYPE").then(
            shipentTypeList => {
                const shipmentTypeDropdownOption = shipentTypeList?.map((shipmentType) => ({
                    dropdownLabel: shipmentType.parameterDtlCode,
                    tagLabel: shipmentType.parameterDtlCode,
                    value: shipmentType.parameterDtlCode,
                })) ?? []

                assignInvoiceCriteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        shipmentTypeDropdownOptions: shipmentTypeDropdownOption
                    }
                }))
            }
        );
    }

    const onResetClick = async () => {
        assignInvoiceCriteriaDispatch(prevState => {

            return {
                ...prevState,
                criteria: { ...EMPTY_ASSIGN_INVOIC_CRITERIA_ENTITY },
            }
        })
    }

    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        return assignInvoiceCriteriaDispatch(prevState => {
            return {
                ...prevState,
                criteria: {
                    ...prevState.criteria,
                    [fieldKey]: val,
                },
            }
        });
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        assignInvoiceCriteriaDispatch(prevState => ({
            ...prevState,
            criteria: {
                ...prevState.criteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onSubmit = async (criteria: AssignInvoiceCriteriaEntity) => {
        return await repo.onSubmit(criteria);
    }

    return {
        onFieldChange: onFieldChange,
        onResetClick: onResetClick,
        loadDropdownOption: loadDropdownOption,
        onDateRangeChange: onDateRangeChange,
        onSubmit: onSubmit,
    }
}